import type { StripeElementsOptionsMode } from '@stripe/stripe-js';

type StripeAppearance = NonNullable<StripeElementsOptionsMode['appearance']>;

// Raw token values mirrored from @change/ds-tokens (see package.json for current version)
// so the Stripe iframe matches surrounding input field styling from createDivInputStyles.
// Stripe's Elements API does not accept CSS custom properties, so these must be literal values.
// If ds-tokens updates these values, update them here too.
const LIGHT_STRIPE_APPEARANCE: StripeAppearance = {
	theme: 'stripe',
	variables: {
		borderRadius: '8px',
		colorText: '#2d2f37',
		colorTextPlaceholder: 'rgba(58, 62, 73, 0.8)',
		colorDanger: '#910a21',
		fontSizeBase: '14px',
	},
	rules: {
		'.Input': {
			border: '1px solid #6f7381',
			boxShadow: 'none',
			padding: '10px 12px',
		},
		'.Input:focus': {
			border: '1px solid transparent',
			boxShadow: '0 0 0 2px #4771ff',
			outline: 'none',
		},
	},
};

const DARK_STRIPE_APPEARANCE: StripeAppearance = {
	theme: 'night',
	variables: {
		borderRadius: '8px',
		colorText: '#ffffff',
		colorTextPlaceholder: '#cbcfda',
		colorBackground: '#1c1e23',
		colorDanger: '#ffe4e9',
		fontSizeBase: '14px',
	},
	rules: {
		'.Input': {
			border: '1px solid #ffffff',
			boxShadow: 'none',
			padding: '10px 12px',
		},
		'.Input:focus': {
			border: '1px solid transparent',
			boxShadow: '0 0 0 2px #a5b9ff',
			outline: 'none',
		},
	},
};

export function getDefaultStripeAppearance({ isDarkMode }: { isDarkMode: boolean }): StripeAppearance {
	return isDarkMode ? DARK_STRIPE_APPEARANCE : LIGHT_STRIPE_APPEARANCE;
}
